/* tslint:disable */
/* eslint-disable */
/**
 * Authentication-API
 * This API allows strong authentication with LuxTrust.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthenticationSamlRequest
 */
export interface AuthenticationSamlRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationSamlRequest
     */
    samlRequest?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationSamlRequest
     */
    url?: string;
}

/**
 * Check if a given object implements the AuthenticationSamlRequest interface.
 */
export function instanceOfAuthenticationSamlRequest(value: object): value is AuthenticationSamlRequest {
    return true;
}

export function AuthenticationSamlRequestFromJSON(json: any): AuthenticationSamlRequest {
    return AuthenticationSamlRequestFromJSONTyped(json, false);
}

export function AuthenticationSamlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationSamlRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'samlRequest': json['saml_request'] == null ? undefined : json['saml_request'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function AuthenticationSamlRequestToJSON(json: any): AuthenticationSamlRequest {
    return AuthenticationSamlRequestToJSONTyped(json, false);
}

export function AuthenticationSamlRequestToJSONTyped(value?: AuthenticationSamlRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'saml_request': value['samlRequest'],
        'url': value['url'],
    };
}

